<div
  class="main-sidebar"
  [class.expanded]="!isCollapsed"
  [class.hidden]="isCollapsed"
  [class.mobile-open]="mobileMenuExpanded$ | async"
  role="navigation"
>
  <div class="sidebar-content">
    <div class="navigation-items-container">
      <div class="collapse-menu-container" [class.collapsed]="isCollapsed">
        <div class="sidebar-heading">
          @if (backLink) {
            <a class="back-link" [class.hidden]="isCollapsed" [routerLink]="backLink.url">
              <ptl-icon [icon]="LucideChevronLeft" [size]="'s'"></ptl-icon>
              <span>{{ backLink.label }}</span>
            </a>
          }

          <div *ngIf="title" [class.hidden]="isCollapsed" class="sidebar-title fs-body-m semibold">
            <span class="title-text">{{ title }}</span>
          </div>
        </div>

        <ptl-button
          class="collapse-btn"
          type="tertiary-neutral"
          [size]="'xs'"
          [icon]="isCollapsed ? LucideChevronsRight : LucideChevronsLeft"
          (click)="onToggleCollapse()"
        ></ptl-button>
      </div>

      <div class="nav-content" [class.hidden]="isCollapsed">
        <div class="sidebar-projected-content">
          <ng-content></ng-content>
        </div>

        <div class="sidebar-projected-footer">
          <ng-content select="[sidebarFooter]"></ng-content>
        </div>
      </div>
    </div>
  </div>
</div>
